// Texty karty z API objektu — slovenské dvojča productCardRender.js.
export default {
  cart: 'Do košíka',
  detail: 'Zobraziť detail',
  cartAria: (name) => 'Do košíka' + ' ' + (name || ''),
  flagAction: 'Zľavoakcia',
};
